import { makeStyles } from "@material-ui/core";

export const useDaySidebarStyles = makeStyles((theme) => ({
  sidebarCard: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2.5),
    height: "100%",
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  headerIcon: {
    color: theme.palette.primary.main,
  },
  sidebarTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  sidebarSubtitle: {
    fontSize: "0.78rem",
    color: "#6b7280",
    marginBottom: theme.spacing(2),
  },
  section: {
    marginBottom: theme.spacing(2),
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sectionDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
  },
  sectionLabel: {
    fontSize: "0.78rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
  },
  fuCard: {
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    backgroundColor: "#f8fafc",
    border: "1px solid #eef0f3",
    borderLeft: "3px solid #cbd5e1",
    marginBottom: theme.spacing(1),
  },
  fuCardTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
  fuName: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#1f2937",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  caseLink: {
    fontSize: "0.78rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    cursor: "pointer",
    whiteSpace: "nowrap",
    "&:hover": { textDecoration: "underline" },
  },
  fuMeta: {
    fontSize: "0.76rem",
    color: "#6b7280",
    marginTop: 2,
  },
  fuActionRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  rescheduleBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.75rem",
    borderRadius: 8,
    padding: "2px 10px",
  },
  actionTaken: {
    fontSize: "0.72rem",
    fontWeight: 600,
    color: "#6b7280",
    fontStyle: "italic",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(4, 1),
    color: "#9aa4b2",
  },
  emptyIcon: {
    fontSize: "2rem",
    color: "#cbd5e1",
  },
  emptyText: {
    fontSize: "0.82rem",
    textAlign: "center",
  },
}));
